import { __assign } from "tslib";
import { loadFromLocalStorage } from "@corporate-trip-planner-fe/ui-components";
export var CREATE_TRIP_KEY = "createTripForm";
export var getInitialValues = function (trip, tripId, initialDraftData) {
    // 1. If we are in EDIT mode AND trip data is loaded: use the trip data.
    if (tripId && trip) {
        // NOTE: We assume a mapping function exists (e.g., mapTripToFormData)
        // that converts your complex Trip entity structure into the flat TripFormData structure.
        return mapTripToFormData(trip);
    }
    // 2. If we are in CREATE mode OR trip data hasn't loaded: check local storage.
    var localStorageDraft = loadFromLocalStorage(CREATE_TRIP_KEY, null);
    if (localStorageDraft) {
        return cleanLoadedData(localStorageDraft);
    }
    // 3. Default to the base initial data.
    return cleanLoadedData(initialDraftData);
};
export var mapTripToFormData = function (trip) {
    var _a, _b, _c;
    // Defensive checks are crucial for nested/optional data
    var locationDetails = trip.locationDetails;
    // Safely map the arrays, providing empty arrays as a default
    var highlights = trip.highlights || [];
    var inclusions = trip.inclusions || [];
    var exclusions = trip.exclusions || [];
    var itinerary = ((_a = trip.itinerary) !== null && _a !== void 0 ? _a : []).map(function (item) { return ({
        day: item.day || "",
        title: item.title || "",
        description: item.description || "",
        activities: [],
    }); });
    // Map categories (which already match the structure, but we ensure defaults)
    /* const tripCategories: { value: string; label: string }[] = (
      (trip.tripCategories as TripCategory[]) || []
    ).map((cat) => ({
      value: cat.value || "",
      label: cat.label || "",
    })); */
    /* const tripCategories: String[] = (
      (trip.tripCategories as TripCategory[]) || []
    ).map((cat) => cat.value); */
    return {
        tripName: trip.tripName || "",
        tripCategories: trip.tripCategories.map(function (item) { return item.value; }),
        status: trip.status || "YET_TO_START",
        source: trip.source || "",
        destination: trip.destination || "",
        startDate: trip.startDate || "",
        endDate: trip.endDate || "",
        description: trip.description || "",
        highlights: highlights,
        inclusions: inclusions,
        exclusions: exclusions,
        itinerary: itinerary,
        coverImageFile: null,
        coverImage: trip.coverImageUrl || null,
        galleryImages: trip.galleryImages || [],
        videoUrl: trip.videoUrl || "",
        privacySetting: trip.privacySetting || "invite-only", // Assuming a default
        modeOfTransport: trip.modeOfTransport || "",
        maxParticipant: trip.maxParticipants || 0, // Assuming maxParticipant is on Trip
        // Map LocationDetails, ensuring null safety for coordinates
        locationDetails: {
            latitude: (_b = locationDetails === null || locationDetails === void 0 ? void 0 : locationDetails.latitude) !== null && _b !== void 0 ? _b : null, // Use null if undefined/missing
            longitude: (_c = locationDetails === null || locationDetails === void 0 ? void 0 : locationDetails.longitude) !== null && _c !== void 0 ? _c : null, // Use null if undefined/missing
            meetingPoint: (locationDetails === null || locationDetails === void 0 ? void 0 : locationDetails.meetingPoint) || "",
            meetingTime: (locationDetails === null || locationDetails === void 0 ? void 0 : locationDetails.meetingTime) || "",
        },
    };
};
export var cleanLoadedData = function (data) {
    // Check if the coverImage is a blob URL, which is invalid after refresh.
    if (data.coverImage && data.coverImage.startsWith("blob:")) {
        return __assign(__assign({}, data), { coverImage: null });
    }
    return data;
};
